<template>
	<router-view></router-view>
</template>

<script>
    export default {
        name: "notice-index"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/productnotice/ProductNoticeIndex.vue